import React from 'react';
import './ContactUs.css';
import chiefImage from '../assets/images/Chief.PNG';

function ContactUs() {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <h2 className="contact-title">Get in Touch</h2>
        <p className="contact-subtitle">Let's make your next event unforgettable</p>
        
        <div className="contact-content">
          <div className="contact-profile">
            <div className="profile-image-wrapper">
              <img 
                src={chiefImage} 
                alt="Chef Prakash Kharel" 
                className="profile-image"
              />
            </div>
            <h3 className="profile-name">Prakash Kharel</h3>
            <p className="profile-title">Chef & Owner</p>
            <p className="profile-experience">With 20+ years of experience in Nepali, Indian, and Italian cuisine, our brand is here to bring our authentic taste of various unique flavors and spices. Our goal is to expand our family business across the nation, spreading the warmth of home-cooked flavors and cultural diversity.</p>
          </div>

          <div className="contact-details">
            <div className="contact-item">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div className="contact-info">
                <h4>Location</h4>
                <a href="https://www.google.com/maps/search/?api=1&query=1033+W+Glebe+Rd+Alexandria+VA+22305"
                   target="_blank" 
                   rel="noopener noreferrer"
                >
                <p>
                  1033 W Glebe Rd <br />
                  Alexandria, VA 22305
                </p>
                </a>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </div>
              <div className="contact-info">
                <h4>Phone</h4>
                <a href="tel:+17039550365" className="contact-link">7039550365</a>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <div className="contact-info">
                <h4>Email</h4>
                <a href="mailto:contact@example.com" className="contact-link">Indonepalculinaryfusion@gmail.com</a>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <div className="contact-info">
                <h4>Business Hours</h4>
                <p>Mon - Thur: 12:00 PM - 11:00 PM<br/>Fri: 12:00 PM - 12:00 AM<br/>Sat: 12:00 AM - 11::00 PM<br/>Sun: 4:30 PM - 10:00 PM</p>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-cta" id="catering">
          <p className="cta-text">Available for catering, private events, and special occasions</p>
          <p className="cta-subtext">More dishes can be made available upon request</p>
          <a href="tel:+17039550365" className="cta-button">Call Now</a>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;

